/* GDPR consent banner. Shows once until a choice is stored. Accept →
   analytics starts; decline → nothing loads. Relevant for EU/Lisbon
   visitors; safe default is no tracking until accepted. */
import { useEffect, useState } from 'react'
import { getConsent, setConsent } from '../lib/consent.js'
import { startAnalytics } from '../lib/analytics.js'

export function ConsentBanner() {
  const [choice, setChoice] = useState(() => getConsent())

  // If a prior visit accepted, start analytics on load.
  useEffect(() => {
    if (choice === 'accepted') startAnalytics()
  }, [choice])

  if (choice) return null

  const decide = (value) => {
    setConsent(value)
    setChoice(value)
    if (value === 'accepted') startAnalytics()
  }

  return (
    <div className="consent" role="dialog" aria-live="polite" aria-label="Privacy consent">
      <p className="consent-text">
        We use privacy-first analytics to understand how the site is used. Nothing is tracked until
        you accept.
      </p>
      <div className="consent-actions">
        <button className="consent-decline" onClick={() => decide('declined')}>
          Decline
        </button>
        <button className="consent-accept" onClick={() => decide('accepted')}>
          Accept
        </button>
      </div>
    </div>
  )
}
